/**
 * An address the reply can actually go to: something, an @, and a domain with
 * a dot in it. Stricter than the browser's own `type="email"` check, which
 * lets `name@host` through — valid on an intranet, a typo on a contact form.
 *
 * Written as an HTML `pattern` so the field's native validation and the
 * script's check are one rule; the attribute anchors it to the whole value.
 */
export const EMAIL_INPUT_PATTERN = '[^\\s@]+@[^\\s@]+\\.[^\\s@]+';

/** The message the browser shows for an address that fails the pattern. */
export const EMAIL_INPUT_TITLE = 'Bitte geben Sie eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de.';

const EMAIL_PATTERN = new RegExp(`^(?:${EMAIL_INPUT_PATTERN})$`);

export const isValidEmail = (value: string) => EMAIL_PATTERN.test(value.trim());
